import { createFileRoute } from "@tanstack/react-router";
import NumeroSuerte from "@/pages/NumeroSuerte";

export const Route = createFileRoute("/numero-suerte")({
  head: () => ({
    meta: [
      { title: "Tus Números de la Suerte - Genera Números Aleatorios | TiemposHoy" },
      {
        name: "description",
        content:
          "Genera tus números de la suerte para jugar en la lotería. Obtén 5 números aleatorios únicos del 00 al 99 para Nicaragua y Costa Rica.",
      },
      { name: "keywords", content: "números de la suerte, números aleatorios, lotería, sorteo, nica, tica" },
      { property: "og:title", content: "Tus Números de la Suerte - Genera Números Aleatorios | TiemposHoy" },
      { property: "og:description", content: "Genera tus números de la suerte para jugar en la lotería. Obtén 5 números aleatorios únicos del 00 al 99 para Nicaragua y Costa Rica." },
      { name: "twitter:card", content: "summary" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://tiemposhoy.com/numero-suerte" },
    ],
    links: [{ rel: "canonical", href: "https://tiemposhoy.com/numero-suerte" }],
  }),
  component: NumeroSuerte,
});
